module.exports = __webpack_public_path__ + "img/myposition_dm_안드레아 피를로.ca60910a.png";